import { Component, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { NotificationService } from '../service/notification.service';
import { NursePractitionerService } from '../service/nursepractitioner.service';
import { ListOfNP } from '../model/availability/availability';

@Component({
  selector: 'app-provider-availability',
  styleUrls: ['./provider-availability.component.scss'],
  templateUrl: './provider-availability.component.html'
})
export class ProviderAvailabilityComponent implements OnInit {

  nursePractitioners: ListOfNP[];
  isLoading = true;
  selectedProviderId;

  constructor(
    public getAllnpService: NursePractitionerService,
    private notificationService: NotificationService,
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.isLoading = true;
    this.getAllnpService.getAllNursePractitioner()
      .pipe(finalize(() => this.isLoading = false))
      .subscribe(result => {
          if (result?.successFlag) {
            this.nursePractitioners = result.nursePractitioners;
          } else {
            this.notificationService.error('An error occurred while loading nurse practitioners.');
          }
        },
        error => {
          console.log(error);
          this.notificationService.error('An error occurred while loading nurse practitioners.');
        }
      );
  }
}
